import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {apiError, handleRequest} from "../../../../utils";
import {requestDemoApi} from "../../../../api";
import {Button, Loading} from "../../../../components";
import {EditorField} from "../../../../components/Forms";


function RequestDemoFormComment({requestDemo, setComments, comments})
{
    const validationSchema = Yup.object().shape({
        comment: Yup.string().required('Bạn chưa điền câu trả lời'),
    })

    const initialValues = {
        comment: '',
    }

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });

    const eventHandlers = {
        submit: async (data) =>
        {
            data.requestId =  requestDemo.id;

            let [error, response] = await handleRequest(requestDemoApi.addComment(data));

            let message = apiError(`Trả lời yêu cầu thất bại`, error, response);

            if (!message)
            {
                setComments([
                    ...comments,
                    response.data,
                ])

                reset(initialValues)
            }
        }
    }

    return (
        <form className="form mt-3" onSubmit={handleSubmit(eventHandlers.submit)}>
            {isSubmitting && <Loading/>}
            <Controller control={control} name="comment" render={({ field }) => (
                <EditorField errors={errors} {...field}/>
            )}/>
            <hr />
            <div className="form-group">
                <Button primary type="submit">Tạo câu trả lời</Button>
            </div>
        </form>
    )
}

export default RequestDemoFormComment;